export const SIGNALS_GUIDE_URL = "https://support.similarweb.com/hc/en-us/articles/11573963021725-Using-Sales-Signals";
